import React from 'react'
// ##
import ViewRep from '../../modules/Rep/components/ViewRep'

export default function RepPage() {
  return <ViewRep />
}
